// extracted by mini-css-extract-plugin
module.exports = {"box":"box--1Dgep","titMod":"titMod--PYfil","tit":"tit--3WmPd"};